module.exports = __webpack_public_path__ + "static/img/why.5c02cd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/why.png
// module id = faW0
// module chunks = 0